import { ArrowUpRight, Check, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  Dialog, DialogTrigger, DialogContent, DialogTitle,
  DialogDescription, DialogClose,
} from './ui/dialog';
import Reveal from './Reveal';
import { products } from '../experienceData';

export default function ProductShowcase() {
  return (
    <section className="experience-section product-showcase" id="products">
      <div className="container">
        <Reveal>
          <div className="section-kicker">06 / GENESYS INFO X PRODUCTS</div>
          <div className="section-heading-row">
            <h2 className="display-title">Products</h2>
            <p>Software for connected operations, clearer insights, and better customer experiences.</p>
          </div>
        </Reveal>
        <div className="product-grid">
          {products.map((product, index) => (
            <Reveal key={product.id} className={index === 0 || index === products.length - 1 ? 'product-featured' : ''} delay={index % 2 * 0.08}>
              <article className="product-card" id={'product-' + product.id}>
                <Dialog>
                  <DialogTrigger asChild>
                    <button className="product-image-link" aria-label={'Explore ' + product.name}>
                      <img src={product.image} alt={product.imageAlt} width="1200" height="800" loading="lazy" />
                      <span className="product-image-shade" />
                      <span className="product-number">Product {product.number}</span>
                      <span className="product-category">{product.category}</span>
                      <span className="product-image-arrow" aria-hidden="true"><ArrowUpRight size={24} /></span>
                    </button>
                  </DialogTrigger>
                  <div className="product-copy">
                    <h3>{product.name}</h3>
                    <p className="product-description">{product.description}</p>
                    <ul className="product-modules" aria-label={product.name + ' features'}>
                      {product.modules.map(module => <li key={module}><Check size={16} aria-hidden="true" /><span>{module}</span></li>)}
                    </ul>
                    <div className="product-actions">
                      <Link className="text-action" to={"/demos/"+product.id}>Try interactive demo<ArrowUpRight size={18}/></Link>
                      <DialogTrigger asChild>
                        <button className="text-action product-explore" aria-label={'View ' + product.name + ' details'}>
                          Explore product <Plus size={18} />
                        </button>
                      </DialogTrigger>
                      <Link className="text-action product-enquire" to="/#contact">Discuss Your Requirements<ArrowUpRight size={18} aria-hidden="true" /></Link>
                    </div>
                  </div>
                  <DialogContent className="detail-dialog product-dialog">
                    <div className="product-dialog-meta">GENESYS INFO X / PRODUCT {product.number}</div>
                    <DialogTitle>{product.name}</DialogTitle>
                    <DialogDescription>{product.description}</DialogDescription>
                    <img className="product-dialog-image" src={product.image} alt={product.imageAlt} width="1200" height="800" />
                    <div className="dialog-story">
                      <h4>Core features</h4>
                      <DialogClose asChild><Link className="btn btn-primary" to={"/demos/"+product.id}>Try interactive demo<ArrowUpRight size={18}/></Link></DialogClose><p>Concept demo with fictional data and simulated integrations.</p>
                      <ul>{product.modules.map(module => <li key={module}><Check size={16} />{module}</li>)}</ul>
                      <DialogClose asChild>
                        <Link className="btn btn-primary" to="/#contact">Discuss Your Requirements<ArrowUpRight size={18} /></Link>
                      </DialogClose>
                    </div>
                  </DialogContent>
                </Dialog>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
